<template>
    <div class="flex min-h-screen w-full flex-col bg-gray-100">
        <!-- Fixed top bar -->
        <div
            class="fixed left-0 right-0 top-0 z-50 flex items-center justify-between bg-white px-4 py-4 shadow-sm sm:justify-center sm:px-6 sm:py-[26px]"
        >
        <InertiaLink :href="'/'">

            <LogoFull :width="120" class="sm:w-[120px]" />
        </InertiaLink>

            <a href="https://topol.io/" class="absolute block sm:hidden right-6">
                <AtomicButton size="sm" color="yellow">
                    Homepage
                </AtomicButton>
            </a>

            <a href="https://topol.io/" class="hidden sm:block absolute sm:right-6">
                <AtomicButton size="md" color="yellow">
                    Go to homepage
                </AtomicButton>
            </a>
        </div>

        <!-- Main content with top padding for fixed header -->
        <div class="flex flex-1 items-start justify-center pt-20 sm:pt-24">
            <slot />
        </div>

        <Notifications />
    </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import {
    authNavigationImages,
    logoutImages,
    preloadImages,
} from '@/utils/preloadAuthImages';

onMounted(() => {
    preloadImages([...authNavigationImages, ...logoutImages]);
});
</script>
